import { lazy } from 'react'

export const PastTries = lazy(() => import('./PastTries'))
